import { List, Record } from "immutable";
import moment from "moment";
import { DeliveryWindow } from "./delivery-window";

const defaults = {
    _id: "",
    default_delivery_window: 30,
    delivery_windows: List(),
    earliest_available_date: undefined,
    latest_available_date: undefined,
    minimum_delivery_window: 1,
    warehouse_id: undefined,
};

export class Availability extends Record(defaults) {
    declare delivery_windows: List<string>;
    declare default_delivery_window: number;
    declare earliest_available_date: moment.Moment;
    declare latest_available_date: moment.Moment;
    declare minimum_delivery_window: number;
    declare _id: string;
    declare warehouse_id: string;

    constructor(args) {
        super({
            ...args,
            delivery_windows: List(args.delivery_windows || []),
            earliest_available_date: moment.utc(args.earliest_available_date),
            latest_available_date: args.latest_available_date && moment.utc(args.latest_available_date),
        });
    }

    getImmediateWindow(entities: DeliveryWindow[]) {
        return this.delivery_windows.filter((modelId) => {
            const model: DeliveryWindow = entities[modelId];
            return model.adjustable_dates && !model.prebook;
        });
    }

    getPreBookWindow(entities: DeliveryWindow[]) {
        return this.delivery_windows.filter((modelId) => {
            const model: DeliveryWindow = entities[modelId];
            return model.adjustable_dates && model.prebook;
        });
    }
}
